export const BREAKPOINT_TABLET = 768;
export const BREAKPOINT_SMALL_DESKTOP = 1024;
export const BREAKPOINT_DESKTOP = 1280;

export type Breakpoint = 'mobile' | 'tablet' | 'small-desktop' | 'desktop';
export type OS = 'ios' | 'android' | 'macos' | 'windows' | 'linux' | 'unknown';

export function detectOS(): OS {
  const ua = navigator.userAgent.toLowerCase();
  const platform =
    (navigator as { userAgentData?: { platform?: string } }).userAgentData?.platform?.toLowerCase() ??
    navigator.platform?.toLowerCase() ??
    '';

  if (/iphone|ipad|ipod/.test(ua) || (platform === 'macintel' && navigator.maxTouchPoints > 1)) {
    return 'ios';
  }
  if (/android/.test(ua)) return 'android';
  if (/mac/.test(platform)) return 'macos';
  if (/win/.test(platform)) return 'windows';
  if (/linux/.test(platform)) return 'linux';
  return 'unknown';
}
